var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
function IconSuccessComponent(props, ref) {
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    _b = props.prefix,
    prefix = _b === void 0 ? 'arco' : _b,
    _c = props.width,
    width = _c === void 0 ? '1em' : _c,
    _d = props.height,
    height = _d === void 0 ? '1em' : _d,
    _e = props.useCurrentColor,
    useCurrentColor = _e === void 0 ? false : _e,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: prefix + "-icon " + prefix + "-icon-Success " + className,
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    fill: useCurrentColor ? 'currentColor' : '#3B9C28'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33 7.271L7.208 9.15l3.585-3.585.848.849-4.433 4.433L4.48 8.12l.849-.849z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }));
}
var IconSuccess = /*#__PURE__*/React.forwardRef(IconSuccessComponent);
export default IconSuccess;